module.exports = __webpack_public_path__ + "static/media/AS.b2acb460.svg";